import { type ChangeEvent } from 'react'

import styled from 'styled-components'

import * as Icons from 'assets/svg/sprite'
import colors from 'styles/colors'

interface IAttachemntProps {
    handleOnChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const Attachment = ({ handleOnChange }: IAttachemntProps) => {
    return (
        <Wrapper>
            <input type='file' multiple onChange={handleOnChange} />
            <Icons.IconImageOutline color={colors.stormyBlue} />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    position: relative;
    input {
        height: 2rem;
        opacity: 0;
        position: relative;
        width: 2rem;
        z-index: 1;
    }
    svg {
        left: 0;
        position: absolute;
        top: 0;
    }
`
